const versions = {
    ui: '314359b7d23afecadd9781429b635ccde80e9688'
};

export default versions;
